import type { PostFormValues } from "@circle-react/components/QuickPostV3/data/types";
import { useSpacesContext } from "@circle-react/contexts/spacesContext";
import {
  showCoverImageSelector,
  showTitleInput,
} from "@circle-react/helpers/postHelpers";
import { canManageSpace } from "@circle-react/helpers/spaceHelpers";
import { useFormContext } from "react-hook-form";

export const useComposerSpace = () => {
  const { watch } = useFormContext<PostFormValues>();
  const {
    helpers: { basicSpacesWithPostCreationAllowed },
  } = useSpacesContext();
  const [spaceId, coverImage] = watch(["space_id", "cover_image"]);
  const space = spaceId
    ? basicSpacesWithPostCreationAllowed().find(({ id }) => id === spaceId)
    : undefined;
  const canShowCover = showCoverImageSelector(space);
  const canShowTitle = showTitleInput(space);
  const canManageSelectedSpace = space ? canManageSpace(space) : false;

  return {
    spaceId,
    space,
    coverImage,
    hasSelectedSpace: Boolean(spaceId),
    hasCover: Boolean(coverImage),
    canShowCover,
    canShowTitle,
    shouldShowAddCover: canShowCover && !coverImage,
    canManageSelectedSpace,
  };
};
